export default "__VITE_ASSET__BysvJ2Zl__"